import React, { Fragment, useState } from "react";
import { withStyles } from '@mui/styles';
import {Card, 
    CardContent,
    TableContainer,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Chip,
    Typography,
    Menu,
    IconButton
} from '@mui/material';

import ListItemIcon from '@mui/material/ListItemIcon';
import CoffeeIcon from '@mui/icons-material/Coffee';
import EngineeringIcon from '@mui/icons-material/Engineering';
import PhoneMissedIcon from '@mui/icons-material/PhoneMissed';
import PhoneCallbackIcon from '@mui/icons-material/PhoneCallback';
import CheckIcon from '@mui/icons-material/Check';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import moment from 'moment';

import OperatorCardModal from "./OperatorCardModal";
import Utils from "../utils";
import { history } from "../../_utils";

const StyledMenu = withStyles({
  paper: {
    height: 34,
    marginLeft: 40,
    boxShadow: 'none',
    '& ul': {
        paddingTop: 2,
        paddingBottom: 0
    },
  }
})(props => (
  <Menu
    {...props}
  />
));

const agentState = (record) => {
    const session = record.sessions?.[0];
    if (session) return Utils.getSessionState(session.state) || {};
    if (record.stateCode) return Utils.getAgentState(record.stateCode) || {};
    return {};
};

const SectionTitle = ({ children }) => (
    <TableRow>
        <TableCell
            colSpan={6}
            style={{
                fontWeight: 600,
                fontSize: '0.875rem',
                paddingTop: 16,
                paddingBottom: 8,
                borderBottom: 'none',
                backgroundColor: 'unset',
            }}
        >
            {children}
        </TableCell>
    </TableRow>
);

const AgentRow = ({ record, openAgent, handleClickOperatorStatus, state, active, color}) => {
    return (
        <TableRow hover tabIndex={-1}>
            <TableCell>
                <div style={{width: '5%', textAlign: 'center'}}>
                        <IconButton
                            size="small"
                            aria-label="more"
                            aria-controls={record.id}
                            aria-haspopup="true"
                            disabled={!state ? true : state.value==='Logoff'}
                            onClick={(e) => handleClickOperatorStatus(e, record)}
                        >
                            {state.icon}
                        </IconButton>
                </div>
                {/* <div>{state.icon}</div> */}
            </TableCell>
            <TableCell onClick={() => openAgent(record)} style={{cursor: 'pointer'}}>
                <div style={{color,  fontWeight: active ? 900 : 'unset'}}>{record.login} {record.name}</div>
                <div style={{fontSize: '0.6rem'}}>{record.station} {state.label || ''}</div>
            </TableCell>
            <TableCell style={{color:'#0a2b61'}}>
                <div style={{ fontWeight: active ? 900 : 'unset'}}>{record.sessions?.[0]?.queue?.name || ''}</div>
                <div>{record.sessions?.[0]?.address || ''}</div>
            </TableCell>
            <TableCell style={{color: '#0a2b61'}}>
                {record.sessions?.[0] ? Utils.secondsToTime(record.sessions[0].lastStateDuration) : record.stateDuration}
            </TableCell>
            <TableCell>
                {record.statistics&&
                    <div style={{display: 'flex', flexDirection: 'row', gap: 2}}>
                            <PhoneCallbackIcon style={{fontSize: '0.8rem', color: '#2e7d32', paddingLeft: 5, width: 20}}/>
                            <div style={{color: '#2e7d32', width: 20}}>{record.statistics.calls.toFixed(0)}</div>
                        {record.statistics.abandoned>0&&
                            <PhoneMissedIcon style={{fontSize: '0.8rem', color: '#ff5722', paddingLeft: 5, width: 20}}/>
                        }
                        {record.statistics.abandoned>0&&
                            <div style={{color: '#ff5722', width: 20}}>{record.statistics.abandoned.toFixed(0)}</div>
                        }
                    </div>
                }
            </TableCell>
            <TableCell>
                {record.statistics&&
                    <Chip style={{fontSize: '0.6rem', height:16}} size='small' color={record.statistics.occPercent<50 ? 'error' : (record.statistics.occPercent<60 ? 'warning' : 'success')} variant='outlined' label={`${record.statistics.occPercent.toFixed(2)}%`}/>
                }
            </TableCell>
        </TableRow>
    )
}

const Agents = ({agents, talk, changeAgentState}) => {
    const [showAgent, setShowAgent] = useState(false);
    const [currentAgent, setCurrentAgent] = useState(null);
    const [openOperatorStatus, setOpenOperatorStatus] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null)

    const openAgent = (agent) => {
        setShowAgent(true);
        setCurrentAgent(agent);
    }

    const handleClickOperatorStatus = (event, agent) => {
        setAnchorEl(event.currentTarget);
        setCurrentAgent(agent)
        setOpenOperatorStatus(true);
    };

    const handleCloseOperatorStatus = () => {
        setAnchorEl(null);
        setOpenOperatorStatus(false);
        if (!showAgent) {
            setCurrentAgent(null);
        }
    };

    const handleClose = () => {
        setShowAgent(false);
        setCurrentAgent(null);
    }

    const goToSchedule = () => {
        const currentDate = moment().format("YYYY-MM-DD");
        history.push(`schedule/${currentDate}/show`);
    }

    const operators = agents.filter((agent) => agent.type === 'operator');
    const training = agents.filter((agent) => agent.type === 'test');
    const staff = agents.filter((agent) => agent.type === 'staf');
    const others = agents.filter((agent) => agent.type !== 'operator' && agent.type !== 'test' && agent.type !== 'staf');

    const renderAgentRows = (list) => list.map((record) => {
        const state = agentState(record);
        const active = record.talking > 0;
        const color = active ? '#1f7a1f' : state.color;
        return (
            <AgentRow
                key={record.id || record.login}
                record={record}
                openAgent={openAgent}
                handleClickOperatorStatus={handleClickOperatorStatus}
                state={state}
                active={active}
                color={color}
            />
        );
    });

    return(
        <Fragment>
            <Card variant="outlined">
                <CardContent>
                    <Typography component="h2" variant="subtitle2" gutterBottom
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between'
                        }}
                    >
                        <div 
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}
                        >
                            <span>Операторы</span>
                            <span>
                                <Chip 
                                    color="info" 
                                    size="small" 
                                    onClick={goToSchedule}
                                    label={`Расписание`}
                                    variant='outlined'
                                    style={{fontSize: '0.6rem', marginRight: 4, cursor: 'pointer'}}
                                />
                                <Chip 
                                    size="small" 
                                    color="success" 
                                    label={`В разговоре: ${talk}`} 
                                    style={{fontSize: '0.6rem', marginRight: 4}}
                                />
                            </span>
                        </div>
                        
                    </Typography>
                    <TableContainer>
                        <Table size="small" stickyHeader aria-label="sticky table">
                            <TableHead style={{color: 'black', backgroundColor: 'unset'}}>
                                <TableRow>
                                    <TableCell style={{color: 'black', backgroundColor: 'unset', fontWeight: 900, width: '5%'}}></TableCell>
                                    <TableCell style={{color: 'black', backgroundColor: 'unset', fontWeight: 900, width: '40%'}}>Оператор</TableCell>
                                    <TableCell style={{color: 'black', backgroundColor: 'unset', fontWeight: 900, width: '35%'}}>Проект/Номер</TableCell>
                                    <TableCell style={{color: 'black', backgroundColor: 'unset', fontWeight: 900, width: '10%'}}>Время</TableCell>
                                    <TableCell style={{color: 'black', backgroundColor: 'unset', fontWeight: 900, width: '10%'}}>Звонки</TableCell>
                                    <TableCell style={{color: 'black', backgroundColor: 'unset', fontWeight: 900, width: '10%'}}>OCC</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {renderAgentRows(operators)}
                                {training.length > 0 && (
                                    <Fragment>
                                        <SectionTitle>Обучение</SectionTitle>
                                        {renderAgentRows(training)}
                                    </Fragment>
                                )}
                                {staff.length > 0 && (
                                    <Fragment>
                                        <SectionTitle>Администрация</SectionTitle>
                                        {renderAgentRows(staff)}
                                    </Fragment>
                                )}
                                {others.length > 0 && (
                                    <Fragment>
                                        <SectionTitle>Другие</SectionTitle>
                                        {renderAgentRows(others)}
                                    </Fragment>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CardContent>
            </Card>
            <StyledMenu
                id="state-menu"
                anchorEl={anchorEl}
                keepMounted
                open={openOperatorStatus}
                onClose={handleCloseOperatorStatus}
                PaperProps={{
                    style: {
                        paddingTop: 0,
                        paddingBottom: 0,
                    },
                }}
            >
                <ListItemIcon>
                        <IconButton onClick={ () => {changeAgentState(currentAgent.id, 536870914); handleCloseOperatorStatus();}}>
                            <CheckIcon style={{color: '#4CAF50', fontSize: '0.8rem'}}/>
                        </IconButton>
                </ListItemIcon>
                <ListItemIcon>
                        <IconButton onClick={ () => {changeAgentState(currentAgent.id, 536870915); handleCloseOperatorStatus();}}>
                            <HighlightOffIcon style={{color: '#F44336', fontSize: '0.8rem'}}/>
                        </IconButton>
                </ListItemIcon>
                <ListItemIcon>
                        <IconButton onClick={ () => {changeAgentState(currentAgent.id, 536870918); handleCloseOperatorStatus();}}>
                            <EngineeringIcon style={{color: '#3f51b5', fontSize: '0.8rem'}}/>
                        </IconButton>
                </ListItemIcon>
                <ListItemIcon>
                        <IconButton onClick={ () => {changeAgentState(currentAgent.id, 536870919); handleCloseOperatorStatus();}}>
                            <CoffeeIcon style={{color: '#FF9800', fontSize: '0.8rem'}}/>
                        </IconButton>
                </ListItemIcon>
                <ListItemIcon>
                        <IconButton onClick={ () => {changeAgentState(currentAgent.id, 536870912); handleCloseOperatorStatus();}}>
                            <ExitToAppIcon style={{ fontSize: '0.8rem'}}/>
                        </IconButton>
                </ListItemIcon>
            </StyledMenu> 
            {showAgent && currentAgent && (
                <OperatorCardModal
                    open={showAgent}
                    agent={currentAgent}
                    onClose={handleClose}
                />
            )}
        </Fragment>
    )
}


export default  Agents;